module.exports = __webpack_public_path__ + "static/demo-f80e9e9c97241f199ec22188517ef74b.mp4";